import packageJson from '../../package.json';

const globals = packageJson.globals || {};

export function setGlobals(source) {
    Object.assign(globals, source);
}

export default globals;
